import { useLabObservationTrend } from '@/patients/services/use-patient-lab-results';
import {
  trendPointsInRange,
  type LabTrendCardModel,
  type LabTrendPoint,
  type TimelineRange,
} from '@/patients/lib/lab-trend-cards';

/** The results of one card in the range, oldest first: shared by the card and the Compare panel (one cached read). */
export function useCardPoints(
  patientId: string,
  card: LabTrendCardModel,
  labsByRoot: ReadonlyMap<string, string>,
  range: TimelineRange,
): { points: LabTrendPoint[]; loading: boolean } {
  const { data, isLoading } = useLabObservationTrend(patientId, card.row.trendKey);
  if (!data || data.storeAvailable === false) return { points: [], loading: isLoading };
  return { points: trendPointsInRange(data.observations, card.row, labsByRoot, range), loading: false };
}
